import React from "react";
import { Box, Stack, Typography, keyframes } from "@mui/material";
import { motion } from "framer-motion";
import Section10B from "./Section10B";
import Section10C from "./Section10C";
import Section10D from "./Section10D";
import OurService from "./ourService";

// Fade-in animation from Section7
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Section10A = () => {
  return (
    <>
      <Box
        component="section"
        aria-label="What We Do - Vertex Suite"
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          style={{ width: "100%" }}
        >
          <Stack
            id="what_we_do"
            component="article"
            sx={{
              backgroundColor: "white",
              maxWidth: { xs: "100%", sm: "90%", md: "1280px" },
              px: { xs: 2, sm: 3, md: 4, lg: 6 },
              py: { xs: 2, sm: 3, md: 3, lg: 3.5 },
              mx: "auto",
              animation: `${fadeIn} 1.2s ease-in`,
            }}
          >
            {/* Header */}
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              mb={{ xs: 1.5, sm: 2, md: 1.5, lg: 2 }}
              mt={{ xs: 0, sm: 0, md: 0, lg: 0 }}
            >
              <Box
                sx={{
                  width: "6px",
                  height: { xs: "22px", sm: "36px", md: "30px" },
                  backgroundColor: "#054E91",
                  borderTopRightRadius: "6px",
                  borderBottomRightRadius: "6px",
                  mr: 2,
                }}
              />
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  fontSize: { xs: "22px", sm: "28px", md: "34px" },
                  color: "#054E91",
                  fontFamily: "'Roboto', sans-serif",
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                  textAlign: "left",
                }}
              >
                What we do?
                {/* <Box component="span" sx={{ color: "#1F85C0" }}>
                  do?
                </Box> */}
              </Typography>
            </Stack>

            {/* Desktop Text */}
            <Typography
              sx={{
                fontSize: { xs: "15px", sm: "17px", md: "20px" },
                lineHeight: { xs: 1.5, sm: 1.8, md: 1.3 },
                fontFamily: "'Roboto', sans-serif",
                color: "text.secondary",
                letterSpacing: "0.3px",
                display: { xs: "none", sm: "block" },
                mb: { xs: 2, sm: 2, md: 1.5, lg: 1.5 },
              }}
            >
              At Vertex Suite, we are not just building a tool-we are building a complete ecosystem. Under the Vertex Suite umbrella, we are developing multiple purpose-driven suites that cater to every critical business function. From marketing and customer support to commerce, operations and analytics-each suite is built to solve a specific problem while seamlessly integrating into a single WhatsApp-first experience. Our ecosystem connects with popular CRMs, eCommerce platforms, social channels, marketing tools, shipping providers, and payment gateways so businesses can manage everything from one centralized hub.
            </Typography>

            {/* Mobile Text */}
            <Typography
              sx={{
                fontSize: { xs: "15px", sm: "17px" },
                lineHeight: { xs: 1.5, sm: 1.8 },
                fontFamily: "'Roboto', sans-serif",
                color: "text.secondary",
                letterSpacing: "0.3px",
                display: { xs: "block", sm: "none" },
                mb: { xs: 2, sm: 2 },
              }}
            >
              At Vertex Suite, we are building a unified WhatsApp-first ecosystem with purpose-driven suites for marketing, support, commerce, operations, and analytics. Each suite solves key business needs and connects with CRMs, eCommerce platforms, payment gateways, and more—so brands can manage everything from one centralized hub.
            </Typography>
          </Stack>
        </motion.div>
      </Box>

      {/* Other Subsections */}
      <Stack
        sx={{
          px: { xs: 2, sm: 3, md: 4, lg: 6 },
        }}
      >
        {/* <Section10B /> */}
        {/* <Section10C /> */}
        {/* <Section10D /> */}
        <OurService />
      </Stack>
    </>
  );
};

export default Section10A;